/* istanbul ignore file */

export const ADD_TO_BASKET_CTA = 'Add to basket';
export const BUY_GIFT_CARD_CTA = 'Buy giftcard';
export const NEW_PRODUCT_LABEL = 'New product';
export const NO_LONGER_AVAILABLE_LABEL = 'Sorry, this item is no longer available';
export const OUT_OF_STOCK_LABEL = 'Sorry, this item is currently out of stock';
export const OUT_OF_STOCK_WITH_DATE_LABEL =
  'Sorry, this item is currently out of stock. It will be available on {DATE}';
export const MADE_TO_ORDER_LABEL = 'Made to order';

export const MADE_TO_ORDER_COPY =
  'Made to order products are created from scratch when you complete your order with the seller. As such, these items have varied lead times before they are dispatched for delivery. This is why the delivery times displayed may be longer. For additional info you can see the product description.';
export const MADE_TO_ORDER_INFO = "What's this";

export const BASKET_MODAL_CONTENT_LABEL = 'Add to Basket Modal';
export const BASKET_MODAL_TOTAL = 'Basket total';
export const BASKET_MODAL_ITEMS = 'items';
export const BASKET_MODAL_QUANTITY = 'Qty';
export const BASKET_MODAL_HEADER = 'Item added to basket';
export const BASKET_MODAL_BUTTON_CONTINUE = 'Continue shopping';
export const BASKET_MODAL_BUTTON_CTA = 'Go to basket';
